









import { Component, Vue } from 'vue-property-decorator';
import VueGallery from 'vue-gallery';

import CardMenu from '../components/CardMenu.vue';
import { CardMenuItem } from '../interfaces/card-menu.interface';
import TranslationApiAgent from '../services/translation-api-agent';
import BbParserService from '../services/bb-parser.service';
import GalleryApiAgent,{ Image } from '@/services/gallery-api-agent';

// @ts-ignore
@Component({
  components: {
    'gallery': VueGallery
  }
})
export default class Gallery extends Vue {

  constructor(
    private galleryApiAgent = GalleryApiAgent,
    private translationApiAgent = TranslationApiAgent) {
    super();
  }

  private index: number = null;
  private images: Image[] = [];

  get folder() {
		return this.$route.params.folder;
  }

  get imgUrls() {
    return this.images.map(img => img.url);
  }

  mounted() {
    this.galleryApiAgent.list(this.folder).then(imgs => { this.images = imgs });
  }

}

